// Module
var code = "<div class=\"question-label-spacer pull-left\">{{ row.label | questionLabel:true }}</div>\n<div item-summary-graph=\"row\"></div>\n";
// Exports
module.exports = code;